import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MyPlayersPage } from './my-players.page';

const routes: Routes = [
  {
    path: '',
    component: MyPlayersPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MyPlayersPageRoutingModule {}
